import { token } from '@atlaskit/tokens';
import { type CSSProperties } from 'react';

import { type PinnedLeadingFieldLayoutItem } from './compute-pinned-leading-layout';
import { PINNED_LEADING_BOUNDARY_BORDER_CSS_VARIABLE } from './pinned-leading-shadow';

export const PINNED_LEADING_CELL_BACKGROUND_CSS_VARIABLE =
  '--database-pinned-leading-cell-background';

export function getPinnedLeadingSurfaceStyle(): Pick<CSSProperties, 'backgroundColor'> {
  return {
    backgroundColor: `var(${PINNED_LEADING_CELL_BACKGROUND_CSS_VARIABLE}, ${token(
      'elevation.surface',
      '#FFFFFF'
    )})`
  };
}

export function getPinnedLeadingStickyCellStyle(
  pinnedLeadingLayout: PinnedLeadingFieldLayoutItem | undefined
): CSSProperties | undefined {
  if (!pinnedLeadingLayout?.isPinned) {
    return undefined;
  }

  return {
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Sticky offset is calculated from column widths.
    left: pinnedLeadingLayout.stickyLeftPx,
    zIndex: pinnedLeadingLayout.bodyZIndex,
    ...getPinnedLeadingSurfaceStyle()
  };
}

export function getPinnedLeadingCellStyle(
  pinnedLeadingLayout: PinnedLeadingFieldLayoutItem | undefined
): CSSProperties | undefined {
  const stickyCellStyle = getPinnedLeadingStickyCellStyle(pinnedLeadingLayout);
  if (!pinnedLeadingLayout || !stickyCellStyle) {
    return undefined;
  }

  return {
    ...stickyCellStyle,
    borderRight: pinnedLeadingLayout.isFreezeBoundary
      ? `var(${PINNED_LEADING_BOUNDARY_BORDER_CSS_VARIABLE}, none)`
      : undefined
  };
}
